// @ts-ignore
import SPINNER from '../assets/images/Spinner.gif';

// export Images
export const SPINNER_IMG = SPINNER;
